// React
import React, { useState, useEffect } from "react";

// Libraries
import PropTypes from "prop-types";
import { Image, Icon, Loader } from "semantic-ui-react";

// Redux
import { connect } from "react-redux";
import downloadFile from "@Redux/Actions/downloads";

// Components
import Text from "@Components/Text";
import Pill from "../Pill";

// Styles
import styles from "./styles.module.css";

const CompanyCard = ({ dispatch, item, isDisabled, onClick, isCurrent }) => {
	const [fileUri, setFileUri] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		(async () => {
			if (item.logo) {
				setIsLoading(true);
				const file = await dispatch(downloadFile({ uri: item.logo }));
				setFileUri(file);
				setIsLoading(false);
			}
		})();
	}, [item.logo]);
	let statusLabel = null;
	if (!item.isActive) {
		statusLabel = (
			<Pill color="red">
				<Icon className={styles.icon} name="ban" />
				<Text className={styles.pillText}>Inactiva</Text>
			</Pill>
		);
	} else if (isCurrent) {
		statusLabel = (
			<Pill>
				<Icon className={styles.icon} name="home" />
				<Text className={styles.pillText}>Actual</Text>
			</Pill>
		);
	}
	return (
		<div className={isDisabled ? styles.disabledContainer : styles.container} onClick={isDisabled ? undefined : onClick}>
			<div className={styles.row}>
				{isLoading && (
					<div className={styles.image}>
						<Loader active inline="centered" />
					</div>
				)}
				{!isLoading && (
					<>
						{fileUri && <Image className={styles.image} src={fileUri} />}
						{!fileUri && <Icon className={styles.image} name="image" />}
					</>
				)}
				<Text className={styles.text}>{item.name}</Text>
			</div>
			<div className={styles.row}>{statusLabel}</div>
		</div>
	);
};

CompanyCard.propTypes = {
	dispatch: PropTypes.func,
	item: PropTypes.object,
	isDisabled: PropTypes.bool,
	isCurrent: PropTypes.bool,
	onClick: PropTypes.func,
};

export default connect()(CompanyCard);
